import React, { useState, useEffect } from 'react';
import '@op/pages/Overview/KeyMetrics/MentionsSentiment/MetricsList/index.scss';
import KPIsCard from './KPIsCard';
import Abnormal from '@home/components/Abnormal';
import { arrayToObj } from '@op/utils';
import './index.scss';

export default function KPIs(props: any) {
  const { filter, competitorGamesData, filterCond, filterAccount, filterLoading } = props;
  const { data, error, loading } = competitorGamesData;

  const [competitorGames, setCompetitorGames] = useState<any[]>([]);
  const [competitorGamesInfo, setCompetitorGamesInfo] = useState<any>(null);
  const wholeGameInfo = data?.main;

  useEffect(() => {
    if (data?.main && data?.competitors) {
      // 异步处理数据
      const games = [data.main, ...data.competitors.games];
      const rankList = [data.main, ...data.competitors.infos];
      const gamesInfo = arrayToObj(rankList, 'edition_unified_id');
      setCompetitorGames(games);
      setCompetitorGamesInfo(gamesInfo);
    }
  }, [data]);
  
  return (
    <Abnormal
      isLoading={loading || filterLoading}
      isError={error}
      classNames={'dbh-kpi-card-abnormal'}
      component={
        competitorGames.length > 0 && competitorGamesInfo ? ( // 确保有值后再渲染组件
          <KPIsCard
            competitorGames={competitorGames}
            wholeGameInfo={wholeGameInfo}
            filter={filter}
            filterCond={filterCond}
            filterAccount={filterAccount}
            showRank={true}
            gameData={competitorGamesInfo}
          />
        ) : null
      }
    />
  );
}
